// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../AccessLogUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useAccessLogUIContext } from "../AccessLogUIContext";

export function AccessLogTable({
  isLoading,
  accessLogListTotalCount,
  currentPage,
  setCurrentPage,
  accessLogList,
}) {
  // AccessLog UI Context
  const accessLogUIContext = useAccessLogUIContext();
  const accessLogUIProps = useMemo(() => {
    return {
      ids: accessLogUIContext.ids,
      setIds: accessLogUIContext.setIds,
      queryParams: accessLogUIContext.queryParams,
      setQueryParams: accessLogUIContext.setQueryParams,
      openReceiptDialog: accessLogUIContext.openReceiptDialog,
      openDeleteDialog: accessLogUIContext.openDeleteDialog,
      openEditDialog: accessLogUIContext.openEditDialog,
    };
  }, [accessLogUIContext]);

  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "ip",
      text: "IP",
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "userId",
      text: "USER",
      formatter: columnFormatters.UserColumnFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "url",
      text: "URL",
      formatter: columnFormatters.UrlColumnFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "method",
      text: "method",
      formatter: columnFormatters.MethodColumnFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "createdAt",
      text: "date",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.DateTimeColumnFormatter,
      style: {
        minWidth: "110px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: accessLogListTotalCount ? accessLogListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: accessLogUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      setCurrentPage(page);
    },
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center accessLog-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={accessLogList === null ? [] : accessLogList}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  accessLogUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: accessLogUIProps.ids,
                //   setIds: accessLogUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={accessLogList} />
              </BootstrapTable>
              <NoRecordsFoundMessage entities={accessLogList} errorMessage={"No access logs found!"} />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
